import { render, staticRenderFns } from "./AboutModel.vue?vue&type=template&id=ff6e34ac&scoped=true"
import script from "./AboutModel.vue?vue&type=script&lang=js"
export * from "./AboutModel.vue?vue&type=script&lang=js"
import style0 from "./AboutModel.vue?vue&type=style&index=0&id=ff6e34ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6e34ac",
  null
  
)

export default component.exports